import {CompositionImageLayer, FinancingCompositionScene} from '@dms/api/shared';

import {randomLowerCaseUUID} from 'shared/web';

import {createCenteredLayerBox} from './createCenteredLayerBox';

export const createImageLayer = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  fileId: string
): CompositionImageLayer => ({
  id: randomLowerCaseUUID(),
  type: 'image',
  ...createCenteredLayerBox(canvas, 0.3, 0.3),
  opacity: 1,
  fileId,
  fit: 'contain',
});
